module.exports = __webpack_public_path__ + "e4792b64aac84c48560defea921fe9d0.png";